import React from 'react';
import { Chip } from '@mui/material';

/**
 * Semantic status pill. Replaces ad-hoc `<Chip color={getStatusColor(x)}>`
 * usage across the app. Owns the status → semantic-color mapping so we never
 * have to repeat the decision (and never get "approved=purple" again).
 *
 * Add new statuses to STATUS_TO_SEMANTIC below.
 */
const STATUS_TO_SEMANTIC = {
  // Generic
  draft: 'default', pending: 'warning', submitted: 'info', sent: 'info',
  approved: 'success', completed: 'success', paid: 'success', active: 'success',
  partial: 'warning', partially_received: 'warning', partially_shipped: 'warning',
  cancelled: 'error', rejected: 'error', overdue: 'error',
  voided: 'default', inactive: 'default', matched: 'info',
  // GR-specific
  inspected: 'info',
  // PO-specific (open = active/in-flight, closed = fully received & done)
  open: 'success', received: 'success', closed: 'default',
  // PO two-stage flow: dispatched-but-not-received
  in_transit: 'info',
  // Wholesale fulfillment
  shipped: 'success', delivered: 'success', invoiced: 'success',
};

function formatLabel(status) {
  return String(status || '')
    .replace(/_/g, ' ')
    .replace(/^\w/, c => c.toUpperCase());
}

export function StatusBadge({ status, size = 'small', variant = 'filled', sx, ...rest }) {
  const semantic = STATUS_TO_SEMANTIC[String(status || '').toLowerCase()] || 'default';
  return (
    <Chip
      label={formatLabel(status)}
      color={semantic}
      size={size}
      variant={variant}
      sx={{ textTransform: 'capitalize', fontWeight: 600, ...sx }}
      {...rest}
    />
  );
}

export default StatusBadge;
